/*@flow*/
import getFilterName from './getFilterName';
import naturalCmp from 'underscore.string/naturalCmp';
import resourceFilters from 'lib/resource/filters';

function compareNaturally(v1: string, v2: string) {
  return naturalCmp(v1.toLowerCase(), v2.toLowerCase());
}

const VALUES = Object.keys(resourceFilters)
  .map(getFilterName)
  .sort(compareNaturally);

export default ((VALUES: any): string[]);
